module.exports = __webpack_public_path__ + "img/ocean-room-2.7cb5edf1.jpg";